var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('MemberNav',{attrs:{"id":"member-nav"}}),_c('router-view',{attrs:{"id":"change-view"}}),(false)?_c('MemberLogin',{attrs:{"id":"member-login"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }